import { createFeature, createReducer, on } from '@ngrx/store';
import { IToastState } from './types/toast-state.interface';
import { toastActions, ToastType } from './actions';

const initialState: IToastState = {
  message: '',
  header: '',
  cssClass: 'app-toast app-toast-success',
  icon: 'checkmark-circle',
  duration: 4000,
  isOpen: false,
};

function getCssClassForType(type: ToastType): string {
  switch (type) {
    case 'success':
      return 'app-toast app-toast-success';
    case 'warning':
      return 'app-toast app-toast-warning';
    case 'error':
      return 'app-toast app-toast-danger';
  }
}

function getHeaderForType(type: ToastType): string {
  switch (type) {
    case 'success':
      return 'Erfolgreich';
    case 'warning':
      return 'Hinweis';
    case 'error':
      return 'Fehler';
  }
}

function getIconForType(type: ToastType): string {
  switch (type) {
    case 'success':
      return 'checkmark-circle';
    case 'warning':
      return 'warning';
    case 'error':
      return 'alert-circle';
  }
}

const toastFeature = createFeature({
  name: 'toast',
  reducer: createReducer(
    initialState,
    on(toastActions.showToast, (state, action) => {
      const type = action.toastType ?? 'success';
      return {
        ...state,
        message: action.message,
        header: action.header ?? getHeaderForType(type),
        cssClass: getCssClassForType(type),
        icon: action.icon ?? getIconForType(type),
        duration: action.duration ?? 4000,
        isOpen: true,
      };
    }),
    on(toastActions.closeToast, (state) => ({
      ...state,
      isOpen: false,
    }))
  ),
});

export const {
  name: toastFeatureKey,
  reducer: toastReducer,
  selectToastState,
  selectIsOpen: selectToastIsOpen,
} = toastFeature;
